import { render, staticRenderFns } from "./ShareGroupModalEmailsListItem.vue?vue&type=template&id=37ddb6ad&scoped=true&"
import script from "./ShareGroupModalEmailsListItem.vue?vue&type=script&lang=js&"
export * from "./ShareGroupModalEmailsListItem.vue?vue&type=script&lang=js&"
import style0 from "./ShareGroupModalEmailsListItem.vue?vue&type=style&index=0&id=37ddb6ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ddb6ad",
  null
  
)

export default component.exports